import React from "react";
import styled, { createGlobalStyle } from "styled-components/macro";
import { CssBaseline } from "@material-ui/core";

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }
  body {
    background:
      radial-gradient(circle at top left, rgba(103, 181, 222, 0.22), transparent 28%),
      radial-gradient(circle at right center, rgba(29, 78, 137, 0.16), transparent 24%),
      linear-gradient(180deg, #eef4fb 0%, #f7f9fc 100%);
  }
`;

const Root = styled.div`
  width: 100%;
  padding: 32px 20px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
  position: relative;

  &::before,
  &::after {
    content: "";
    position: absolute;
    border-radius: 999px;
    filter: blur(2px);
    pointer-events: none;
  }

  &::before {
    width: 260px;
    height: 260px;
    top: 10%;
    left: 6%;
    background: rgba(103, 181, 222, 0.18);
  }

  &::after {
    width: 320px;
    height: 320px;
    right: 4%;
    bottom: 8%;
    background: rgba(29, 78, 137, 0.12);
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 1100px;
  position: relative;
  z-index: 1;
`;

const SignInLayout = ({ children }) => {
  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <Content>{children}</Content>
    </Root>
  );
};

export default SignInLayout;
